
import { Component, Prop, Host, h, State, Fragment } from '@stencil/core';



import Swiper from 'swiper/swiper-bundle.min.js'





@Component({
  tag: 'swiper-component',
  styleUrl: 'swiper-component.css',
  // shadow: true,
  scoped: true
})
export class SwiperComponent {
 /**
   *Required - Unique ID.
   */
   @Prop() componentid: string = "comp-id";

   /**
   *Required - List Name.
   */
   @Prop() listname: string = "ListName";
 
   /**
   *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
   */
   @Prop() webpath: string = "/";
 
   /**
   *Required - if header attribute is true
   */
   @Prop() sectiontitle: string = "Section Title";
 
   /**
   *Required - if header attribute is true
   */
   @Prop() titleiconurl: string = "";
 
   /**
  *Optional - To show/hide header. default is true
  */
   @Prop() header: boolean = true;
 
   /**
  *Optional - vertical scroll bar
  */
   @Prop() verticalscroll: boolean = false;
 
   /**
  *Optional - vertical scroll bar height
  */
   @Prop() verticalscrollheight: number = 200;
 
   /**
  *Optional - To show see All link
  */
   @Prop() seeall: boolean = false;
   /**
  *Optional - see All Url
  */
   @Prop() seeallurl: string;
 
   /**
 *Optional - see All link Title
 */
   @Prop() seealltitle: string = "See All";
 
   /**
     *Optional - number of items to retrieve
     */
   @Prop() count: number = 100;
 
   /**
 *Optional - header background color
 */
   @Prop() headerbgcolor: string = "white"
 
   /**
   *Optional -header text color
   */
   @Prop() headertextcolor: string = "black"
   /**
   *Optional -header border bottom css
   */
   @Prop() headerborderbottom: string = "1px solid #CE2127"
 
 
   /**
   *Optional - headertext location
 */
   @Prop() headerlocation: string = "top";
 
 
 
 
 
   /**
 *Optional - is it SP Online site
 */
   @Prop() online: boolean = false;
 
   /**
    *Required - site url if its sp online site
    */
   @Prop() siteurl: string = "";
 
   @State() items: []= []
   @State() isLoading: boolean = false
 
  componentDidRender() {



    // setTimeout(
    //   function () {

    //     const swiper = new Swiper(".mySwiper", {
    //       pagination: {
    //         el: ".swiper-pagination",
    //         clickable: true,
          
    //       },
    //       navigation: {
    //         nextEl: ".swiper-button-next",
    //         prevEl: ".swiper-button-prev",
    //       },

    //     });

    //   }, 2000);



      const swiper = new Swiper(".mySwiper", {
        // direction: "vertical",
      
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          // renderBullet: function (index, className) {
          //   return '<span class="' + className + '">' + (index + 1) + "</span>";
          // }
        },
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },

      });


  }

  getContents = () => {

    const returnArray = []


    returnArray.push(

      <div class="swiper mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img class="img-fluid mx-auto d-block" src="https://infonet.nyp.org/ai/Lists/Announcements/NewForm/pulseimage.jpg" alt="" />
          </div>
          <div class="swiper-slide">
            <img  class="img-fluid mx-auto d-block" src="https://infonet.nyp.org/ai/Lists/Announcements/EditForm/AANHPI%20Logo%20Infonet.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img  class="img-fluid mx-auto d-block" src="https://infonet.nyp.org/ai/Lists/Announcements/NewForm/resized_image_for_PX_Training.jpg" alt="" />
          </div>
        </div>

        {/* <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div> */}
        <div class="swiper-pagination"></div>
      </div>
    )

    return returnArray
  }
  render() {
    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"

      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }

    let sliderid = this.componentid + '-' + 'slider'

    return (

      this.isLoading ? <loader-component /> :

        this.header && this.items.length > 0 ?
          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0" style={parentstyle}>
              <div style={styleWithHeader}>
              
                {this.getContents()}
                </div>

          
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle}>
            <div style={style}>
             
              {this.getContents()}
          

            </div>
          </div>




      
    );
  }

}
